const initialState = {
    str: ''
}

const stcwNumberRed = (state = initialState, action) => {
    switch(action.type){
        case 'STCW_NUMBER' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default stcwNumberRed